import VChart from 'vue-echarts';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { BarChart } from 'echarts/charts';
import { GridComponent } from 'echarts/components';

import labelBg from './images/bar.png';

use([BarChart, GridComponent, CanvasRenderer]);
const optionColors = [
  ['101, 229, 46', '0, 128, 51'],
  ['190, 25, 255', '94, 0, 153'],
  ['0, 102, 102', '0, 102, 102'],
  ['0, 153, 38', '0, 153, 38'],
  ['143, 191, 0', '143, 191, 0'],
];

export default {
  name: 'componentsBar',

  props: {
    colors: {
      type: Array,
    },
    chartData: {
      type: Object,
    },
    lableType: {
      type: Number,
    },
    flag: {
      type: Boolean,
    },
    isAcition: {
      type: Boolean,
    },
    showX: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    flag(e) {
      this.datainit();
      if (this.isAcition) {
        if (this.actionTimer) {
          this.stopActions();
        }
        this.startActions();
      } else {
        this.timerfn();
      }
    },
  },
  components: {
    VChart,
  },

  data() {
    return {
      actionTimer: null,
      option: {
        grid: {
          top: "21%",
          left: "5%",
          right: "10%",
          bottom: 0,
          containLabel: true
        },
        xAxis: [
          {
            show: this.showX,
            type: "category",
            data: [],
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: "#747375",
              fontSize: 10,
              fontFamily: "Century Gothic"
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#ddd",
                opacity: 0.1
              }
            },
            boundaryGap: false
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#747375",
              margin: this.lableType === 2 ? 23 : 13,
              fontSize: 10,
              fontFamily: "Century Gothic"
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: []
      }
    };
  },

  created() {
    this.datainit();
  },

  mounted() {
    if (this.isAcition) {
      this.startActions();
    } else {
      setInterval(() => {
        this.timerfn();
      }, 8000);
    }
  },
  beforeDestroy() {
    this.stopActions();
  },
  methods: {
    startActions() {
      console.log('startActions');
      let dataIndex = -1;
      const { bar } = this.$refs;
      if (!bar) {
        return;
      }
      const dataLen = bar.option.series[0].data.length;
      this.actionTimer = setInterval(() => {
        bar.dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
          dataIndex,
        });
        dataIndex = (dataIndex + 1) % dataLen;
        // 高亮当前图形
        bar.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex,
        });
        // 显示 tooltip
        bar.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex,
        });
      }, 2000);
    },
    stopActions() {
      console.log('stopActions');
      clearInterval(this.actionTimer);
    },
    timerfn() {
      const { $refs, option } = this;
      const { bar } = $refs;
      if (!bar) {
        return;
      }
      bar.clear();
      bar.setOption(option);
    },
    datainit() {
      const {
        option, colors, lableType, chartData,
      } = this;
      const { category, series } = chartData;
      if (lableType === 1) {
        option.xAxis[0].data = category.map((item) => item[0]);
      }
      if (lableType === 2) {
        option.xAxis[0].data = category;
      }
      const seriesFormat = [];
      const arr = series.filter((item) => item.show);
      arr.forEach((item, index) => {
        let obj = {};
        if (item.type) {
          obj = {
            type: 'line',
            data: [],
            smooth: true,
            emphasis: {
              lineStyle: {
                width: 6,
              },
              itemStyle: {
                color: '#db2365',
                shadowBlur: 3,
                borderColor: '#fff',
                borderWidth: 2,
                shadowColor: 'rgba(0, 0, 0, 0.35)',
              },
            },
            lineStyle: {
              normal: {
                width: 3,
                color: {
                  type: 'linear',
                  colorStops: [
                    {
                      offset: 0,
                      color: `rgba(${optionColors[item.colors][0]})`,
                    },
                    {
                      offset: 1,
                      color: `rgba(${optionColors[item.colors][1]})`,
                    },
                  ],
                },
                cap: 'round',
                shadowBlur: 5,
                shadowColor: `rgba(${optionColors[item.colors][0]})`,
                shadowOffsetY: 3,
              },
            },
            showSymbol: false,
          };
          obj.name = item.name;
          obj.data = item.value;
        } else {
          obj = {
            type: 'bar',
            data: [],
            barWidth: 13,
            itemStyle: {
              barBorderRadius: 20,
            },
            emphasis: {
              label: {
                show: true,
                rich: {
                  bg: {
                    width: 83,
                    height: 6,
                    backgroundColor: {
                      image: labelBg,
                    },
                  },
                  arial: {
                    fontFamily: 'Arial',
                  },
                  num: {
                    color: '#ffb433',
                    fontWeight: 'bold',
                    fontFamily: 'Arial',
                  },
                },
                align: 'center',
                textStyle: {
                  color: '#fff',
                },
                position: 'top',
                formatter(params) {
                  const { name, value, dataIndex } = params;
                  let str = `{arial|${name}}\n {num|${value}}${
                    item.unit ? item.unit : '万亩'
                  }\n {bg|}`;
                  if (lableType === 1) {
                    str = `{arial|${category[dataIndex][1]}}{arial|${name}}\n {num|${value}}${
                      item.unit ? item.unit : '头'
                    }\n {bg|}`;
                  }
                  return str;
                },
              },
              itemStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#ffd400',
                    },
                    {
                      offset: 1,
                      color: '#cc8800',
                    },
                  ],
                },
              },
            },
          };
          obj.name = item.name;
          obj.data = item.value;
          if (item.stack) {
            obj.stack = item.stack;
            if (arr.length == 1) {
              obj.itemStyle.barBorderRadius = [20, 20, 0, 0];
            } else {
              if (index === 0) {
                obj.itemStyle.barBorderRadius = [0, 0, 20, 20];
              } else if (index === (arr && arr.length - 1)) {
                obj.itemStyle.barBorderRadius = [20, 20, 0, 0];
              } else {
                obj.itemStyle.barBorderRadius = 0;
              }
            }
          }
          obj.itemStyle.color = {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: `rgba(${optionColors[item.colors][0]})`,
              },
              {
                offset: 1,
                color: `rgba(${optionColors[item.colors][1]})`,
              },
            ],
          };
        }
        seriesFormat.push(obj);
      });
      option.series = seriesFormat;
    },
  },
};
